import { render, staticRenderFns } from "./qnaListPage.vue?vue&type=template&id=07233f41&scoped=true&"
import script from "./qnaListPage.vue?vue&type=script&lang=js&"
export * from "./qnaListPage.vue?vue&type=script&lang=js&"
import style0 from "./qnaListPage.vue?vue&type=style&index=0&id=07233f41&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07233f41",
  null
  
)

export default component.exports